import React, { useMemo, useState, useEffect } from "react"
import { Col, Container, Form, Row, Table, Pagination } from "react-bootstrap"
import { Link } from "react-router-dom"
import { addBreadCrumbLinks } from "../commonComponents/EventHandler"

const SearchResultNew = ({ results, completeData, handleClientSearch, onSelectItems }) => {
   const useSortableData = (items, config = null) => {
      const [sortConfig, setSortConfig] = useState(config)
      const sortedItems = useMemo(() => {
         let sortableItems = [...items]
         if (sortConfig !== null) {
            sortableItems.sort((a, b) => {
               if (sortConfig.key === "releaseDateForUiSorting") {
                  if (new Date(a[sortConfig.key]) < new Date(b[sortConfig.key])) {
                     return sortConfig.direction === "ascending" ? -1 : 1
                  }
                  if (new Date(a[sortConfig.key]) > new Date(b[sortConfig.key])) {
                     return sortConfig.direction === "ascending" ? 1 : -1
                  }
                  return 0
               } else {
                  if (a[sortConfig.key] < b[sortConfig.key]) {
                     return sortConfig.direction === "ascending" ? -1 : 1
                  }
                  if (a[sortConfig.key] > b[sortConfig.key]) {
                     return sortConfig.direction === "ascending" ? 1 : -1
                  }
                  return 0
               }
            })
         }
         return sortableItems
      }, [items, sortConfig])

      const requestSort = (key) => {
         let direction = "ascending"
         if (
            sortConfig &&
            sortConfig.key === key &&
            sortConfig.direction === "ascending"
         ) {
            direction = "descending"
         }
         setSortConfig({ key, direction })
      }
      return { items: sortedItems, requestSort, sortConfig }
   }

   const [resultsPerPage, setResultsPerPage] = useState(20)
   const [currentPage, setCurrentPage] = useState(1)
   const indexOfLastResult = currentPage * resultsPerPage
   const indexOfFirstResult = indexOfLastResult - resultsPerPage
   const { items, requestSort, sortConfig } = useSortableData(results)
   const currentResult = items.slice(indexOfFirstResult, indexOfLastResult)
   const [activePage, setActivePage] = useState(1)

   const [choices, setChoices] = useState([])
   const [isAllSelected, setIsAllSelected] = useState(false)

   useEffect(() => {
      setChoices([])
      setIsAllSelected(false)
   }, [results])

   function toggleSelectAll() {
      if (isAllSelected) {
         setChoices([])
         setIsAllSelected(false)
         if (onSelectItems) onSelectItems([])
      } else {
         const allNames = items.map(item => item.name).filter(Boolean)
         setChoices(allNames)
         setIsAllSelected(true)
         if (onSelectItems) onSelectItems(allNames)
      }
   }

   function toggleCheckbox(e) {
      const val = e.target.value
      const newChoices = choices.includes(val)
         ? choices.filter(c => c !== val)
         : [...choices, val]
      setChoices(newChoices)
      setIsAllSelected(newChoices.length > 0 && newChoices.length === items.length)
      if (onSelectItems) onSelectItems(newChoices)
   }

   const getClassNamesFor = (name) => {
      if (!sortConfig) {
         return "fa fa-sort"
      } else if (sortConfig.key === name) {
         if (sortConfig.direction === "ascending") {
            return "fa fa-caret-up"
         } else {
            return "fa fa-caret-down"
         }
      } else {
         return "fa fa-sort"
      }
   }
   
   const info_content = currentResult.map((key, index) => {
      return (
         <tr key={index}>
            {onSelectItems && (
               <td width="30px" align="center" style={{ verticalAlign: "middle" }}>
                  <input
                     type="checkbox"
                     name="gcasCheckbox"
                     value={key.name}
                     onChange={toggleCheckbox}
                     checked={choices.includes(key.name)}
                  />
               </td>
            )}
            <td width="10%">
               {key.link && key.id ? (
                  <Link
                     style={{ textDecoration: "none", color: "#007bff" }}
                     onMouseEnter={(e) => e.currentTarget.style.textDecoration = "underline"}
                     onMouseLeave={(e) => e.currentTarget.style.textDecoration = "none"}
                     onClick={() => {
                        const linkPath = `/${key.link.toUpperCase().trim()}/${key.id.trim()}`
                        // Always replace the entire breadcrumb with only this part entry.
                        // This ensures the top-right corner shows exclusively the last clicked
                        // part name, regardless of type changes (FOP → APMP) or whether a
                        // previous entry was added by addBreadCrumbLinks or BreadCrumb.js.
                        sessionStorage.setItem(
                           "breadCrumb",
                           btoa(JSON.stringify([{ name: key.name, link: linkPath, fromSearchResults: true }]))
                        )
                     }}
                     to={`/${key.link.toUpperCase().trim()}/${key.id.trim()}`}
                  >
                     <span textalign="left">{key.name}</span>
                  </Link>
               ) : (
                  <span>{key.name}</span>
               )}
            </td>
            <td align="left" width="5%">
               {key.revision}
            </td>
            <td align="left" width="10%">
               {key.displaytype}
            </td>
            <td align="left" width="10%" className = "keepSpace">
               {key.title}
            </td>
            <td align="left" width="10%" className = "keepSpace">
               {key.description}
            </td>
            <td align="left" width="10%">
               {key.maturityState}
            </td>
            <td align="left" width="10%">
               {key["lastModification"]}
            </td>
            <td align="left" width="10%">
               {key["releasedate"]}
            </td>
            <td align="left" width="10%">
               {key["creationDate"]}
            </td>
            <td align="left" width="10%">
               {key["originator"]}
            </td>
         </tr>
      )
   })
   


   function handlePageChange(pageNumber) {
      setCurrentPage(pageNumber)
      setActivePage(pageNumber)
   }

   function handleSearchChange(e) {
        
        var re1 = new RegExp(e.target.value, 'i');
        var matches = completeData.filter(matcher(re1));
        handleClientSearch(matches)
        setActivePage(1)
        setCurrentPage(1)
    }
    
    function matcher(regexp) {
        return function (obj) {
        var found = false;
        Object.keys(obj).forEach(function(key){
          if ( ! found) {
            if ((typeof obj[key] == 'string') && regexp.exec(obj[key])) {
              found = true;
            }
          }
        });
        return found;
        };
      } 

      const totalPages = Math.ceil(results.length / resultsPerPage)

   const renderPaginationItems = () => {
      const items = []
      const maxPagesToShow = 5
      let startPage = Math.max(1, activePage - Math.floor(maxPagesToShow / 2))
      let endPage = Math.min(totalPages, startPage + maxPagesToShow - 1)

      if (endPage - startPage + 1 < maxPagesToShow) {
         startPage = Math.max(1, endPage - maxPagesToShow + 1)
      }

      if (activePage > 1) {
         items.push(
            <Pagination.First key="first" onClick={() => handlePageChange(1)} />,
            <Pagination.Prev key="prev" onClick={() => handlePageChange(activePage - 1)} />
         )
      }

      for (let page = startPage; page <= endPage; page++) {
         items.push(
            <Pagination.Item
               key={page}
               active={page === activePage}
               onClick={() => handlePageChange(page)}
            >
               {page}
            </Pagination.Item>
         )
      }

      if (activePage < totalPages) {
         items.push(
            <Pagination.Next key="next" onClick={() => handlePageChange(activePage + 1)} />,
            <Pagination.Last key="last" onClick={() => handlePageChange(totalPages)} />
         )
      }

      return items
   }

   return (
        <React.Fragment>
            <Container fluid className="searchDataContainer" style={{ paddingLeft: 0, paddingRight: 0 }}>
                <Row className="mt-4 mb-3" style={{ marginLeft: 0, marginRight: 0 }}>
                    <Col md={3} sm={2} align="left">
                    <div style={{ width: "100%" }}>
                        <table style={{ textAlign: "center", width: "80%" }}>
                            <tbody>
                                <tr>
                                <td
                                    style={{
                                        width: "25%",
                                        verticalAlign: "middle",
                                        textAlign: "left",
                                    }}
                                >
                                    Page Size:
                                </td>
                                <td style={{ width: "40%", textAlign: "left", }}>
                                    <Form.Control
                                        as="select"
                                        onChange={(e) => {
                                            setResultsPerPage(e.target.value)
                                            setCurrentPage(1)
                                            setActivePage(1)
                                        }}
                                        className="vendorOptions"
                                    >
                                        <option value="20">20</option>
                                        <option value="50">50</option>
                                        <option value="100">100</option>
                                    </Form.Control>
                                </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    </Col>
                    <Col md={1} sm={1} align="right" style={{ paddingTop:"5px"}}>
                        Search:
                    </Col>
                    <Col md={2} sm={2} align="left">
                        <Form.Control type="text" className="vendorOptions-search" onChange={handleSearchChange}/>
                    </Col>
                    <Col md={6} sm={7} align="right">
                    <div
                        style={{ width: "40%", verticalAlign: "middle" }}
                        id="paginTab"
                    >
                        <Pagination>{renderPaginationItems()}</Pagination>
                    </div>
                    </Col>
                </Row>
                <div className="searchScrollbar">
                    <Table bordered className="bordered-table">
                        <thead id="infoTab">
                        <tr>
                            {onSelectItems && (
                               <th width="30px" style={{ textAlign: "center", verticalAlign: "middle" }}>
                                  <input
                                     type="checkbox"
                                     checked={isAllSelected}
                                     onChange={toggleSelectAll}
                                     title="Select All"
                                  />
                               </th>
                            )}
                            <th width="10%">
                                Name&nbsp;
                                <i
                                    onClick={() => requestSort("name")}
                                    className={getClassNamesFor("name")}
                                ></i>
                            </th>
                            <th width="5%">
                                Revision
                            </th>
                            <th width="10%">
                                Type &nbsp;
                                <i
                                    onClick={() => requestSort("displaytype")}
                                    className={getClassNamesFor("displaytype")}
                                ></i>
                            </th>
                            <th width="10%">Title &nbsp;</th>
                            <th width="10%">Description &nbsp;</th>
                            <th width="10%">Maturity State &nbsp;</th>
                            <th width="10%">Last Modification Date &nbsp;</th>
                            <th width="10%">
                                Release Date &nbsp;
                                <i
                                    onClick={() => requestSort("releaseDateForUiSorting")}
                                    className={getClassNamesFor("releaseDateForUiSorting")}
                                ></i>
                            </th>
                            <th width="10%">Creation Date &nbsp;</th>
                            <th width="10%">Originator &nbsp;</th>
                        </tr>
                        </thead>
                        <tbody>{info_content}</tbody>
                    </Table>
                </div>
                </Container>
      </React.Fragment>
   )
}

export default SearchResultNew